export class SelectUser {
    id: string;
    text: string;
    roles: string;

    constructor(id: string, text: string, roles: string) {
        this.id = id;
        this.text = text;
        this.roles = roles;
    }
}



// WEBPACK FOOTER //
// ./src/app/management/components/impersonate/selectUser.ts